import * as React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { ProductImages } from '@estee/elc-images';
import { IMantleMedia } from '~domain/entities/Node';

const BasicToutMediaWrapper = styled.div`
    max-width: 100%;
    height: ${(props) => (props.theme.hasMedia ? 'auto' : '100%')};
    background-color: ${(props) =>
        props.theme.backgroundColor ? `#${props.theme.backgroundColor}` : null};
`;

const MediaAssetWrapper = styled.div`
    background-color: ${(props) =>
        props.theme.backgroundColor ? props.theme.backgroundColor : null};

    > video {
        width: 100%;
    }
`;

interface IMedia extends IMantleMedia {
    className?: string;
}

export const MantleMedia = (props: IMedia) => {
    const { src, alt, device_mp4_url, hex, background_color_fallback, html, className } = props;
    const classNames = classnames('elc-media-asset', 'js-media-asset', 'mantle-media-asset');
    const hasMedia = !!(src || device_mp4_url);

    return html ? (
        <BasicToutMediaWrapper
            className={classnames(className)}
            theme={{ backgroundColor: hex, hasMedia }}
        >
            <MediaAssetWrapper
                className={classNames}
                theme={{ backgroundColor: background_color_fallback }}
            >
                {device_mp4_url ? (
                    <video muted loop autoPlay playsInline poster={src}>
                        <source src={device_mp4_url} type="video/mp4" />
                        {background_color_fallback ? null : (
                            <ProductImages imgPath={src} altText={alt} />
                        )}
                    </video>
                ) : (
                    <>
                        {background_color_fallback ? null : (
                            <ProductImages imgPath={src} altText={alt} />
                        )}
                    </>
                )}
            </MediaAssetWrapper>
        </BasicToutMediaWrapper>
    ) : null;
};
